import type { LedgerEntry } from "@zworks/console-contracts";
import { ledgerQuery } from "./api";

/** Read every page in the month, independently of the visible ledger's filter and page. */
export async function monthlyLedger(projectId: string, now: Date, signal: AbortSignal) {
  const start = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1);
  const entries = new Map<string, LedgerEntry>();
  for (let page = 1; page <= 100; page += 1) {
    const result = await ledgerQuery(projectId, "usage", page).queryFn({ signal });
    for (const entry of result.entries) entries.set(entry.id, entry);
    if (
      page * result.pageSize >= result.total ||
      result.entries.some((entry) => Date.parse(entry.createdAt) < start)
    ) {
      return [...entries.values()];
    }
    if (result.entries.length === 0) break;
  }
  throw new Error("Monthly ledger could not be read completely.");
}
